"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _qrcodejs = _interopRequireDefault(require("qrcodejs2"));
var _esign = require("@/api/esign");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'EsignContract',
  data: function data() {
    return {
      previewVisible: false,
      previewLoading: false,
      previewTitle: '合同预览',
      previewUrl: '',
      previewBlobUrl: '',
      previewError: '',
      statusMap: {
        1: {
          text: '待签署',
          tag: 'warning'
        },
        2: {
          text: '已完成',
          tag: 'success'
        },
        4: {
          text: '已撤销',
          tag: 'info'
        }
      },
      query: {
        status: null,
        keywords: '',
        page: 1,
        limit: 20
      },
      list: [],
      total: 0,
      loading: false,
      signVisible: false,
      signUrl: '',
      signRow: null,
      pendingCount: 0
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    search: function search() {
      this.query.page = 1;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      (0, _esign.esignPendingCountApi)().then(function (n) {
        return _this.pendingCount = n || 0;
      });
      this.loading = true;
      (0, _esign.esignContractListApi)(this.query).then(function (res) {
        _this.list = res.list || [];
        _this.total = res.total || 0;
      }).finally(function () {
        return _this.loading = false;
      });
    },
    sign: function sign(row) {
      var _this2 = this;
      this.signRow = row;
      (0, _esign.esignContractSignUrlApi)(row.id).then(function (res) {
        _this2.signUrl = res && res.url || '';
        _this2.signVisible = true;
        _this2.$nextTick(function () {
          _this2.$refs.qrcode.innerHTML = '';
          if (_this2.signUrl) new _qrcodejs.default(_this2.$refs.qrcode, {
            text: _this2.signUrl,
            width: 200,
            height: 200
          });
        });
      });
    },
    /** 签完反馈给平台，平台在腾讯电子签核对后确认完成 */reportSigned: function reportSigned() {
      var _this3 = this;
      (0, _esign.esignReportSignedApi)(this.signRow.id).then(function () {
        _this3.$message.success('已反馈，等待平台确认');
        _this3.signVisible = false;
      });
    },
    openUrl: function openUrl() {
      window.open(this.signUrl, '_blank');
    },
    /**
     * 合同 PDF 在 OSS 默认域名上会被强制下载，先取成 Blob 再以 application/pdf 内嵌显示。
     */
    download: function download(row) {
      var _this4 = this;
      this.revokePreview();
      this.previewTitle = row.contractName || '合同预览';
      this.previewError = '';
      this.previewUrl = '';
      this.previewVisible = true;
      this.previewLoading = true;
      (0, _esign.esignContractDownloadApi)(row.id).then(function (url) {
        _this4.previewUrl = url;
        return fetch(url);
      }).then(function (res) {
        if (!res.ok) throw new Error(String(res.status));
        return res.blob();
      }).then(function (blob) {
        _this4.previewBlobUrl = URL.createObjectURL(new Blob([blob], {
          type: 'application/pdf'
        }));
      }).catch(function () {
        _this4.previewError = '无法在线加载合同（文件服务器未允许跨域访问），请点「新窗口打开」查看或下载。';
      }).finally(function () {
        _this4.previewLoading = false;
      });
    },
    revokePreview: function revokePreview() {
      if (this.previewBlobUrl) URL.revokeObjectURL(this.previewBlobUrl);
      this.previewBlobUrl = '';
    },
    openPreviewNew: function openPreviewNew() {
      var url = this.previewBlobUrl || this.previewUrl;
      if (url) window.open(url, '_blank');
    }
  }
};